import { alignScroll } from "shared/itemLists/redux/itemListsSlice";

const alignScrollMiddleware = (store) => (next) => (action) => {
  const removeActions = {
    "itemLists/removeBlankTask": true,
    "itemLists/removeEmptyDay": true,
  };
  function getBehavior(action) {
    return action.payload.method === "scroll" ? "auto" : "smooth";
  }

  if (removeActions[action.type]) {
    const adjustIndex = action.type === "itemLists/removeEmptyDay" ? 0 : -1;
    store.dispatch(
      alignScroll({ adjustIndex: adjustIndex, behavior: getBehavior(action) })
    );
  }
  // remove adjustment has to happen early.
  // when adding, it can't happen until the newly added item exists
  const nextAction = async () => {
    next(action);
  };
  nextAction().then(() => {
    if (
      action.type === "itemLists/saveNewTask" &&
      action.payload.position === 0
    ) {
      store.dispatch(alignScroll({ behavior: getBehavior(action) }));
    } else if (
      action.type === "itemLists/saveNewTask" ||
      (action.type === "itemLists/addBlankTask" &&
        action.payload.position !== 0)
    ) {
      store.dispatch(alignScroll({ behavior: getBehavior(action) }));
    }
  });
};

export default alignScrollMiddleware;
